import { callProcedure } from 'core/classes/helpers/callProcedure'
import { IFetchDataFn } from 'partner360/widgets/assortmentTab/context/models/IFetchDataFn'

import { IAssortmentGroup } from '../models/data/IAssortmentGroup'

export const fetchAssortmentGroups: IFetchDataFn<IAssortmentGroup> = async ({
  partnerId,
  programType,
  fYear,
  category,
}) => {
  try {
    const mappedParams: Record<string, any> = {
      'p.PartnerId': partnerId,
      'p.ProgramType': programType,
      'p.FYear': fYear,
      'p.Category': category,
    }

    const response: IAssortmentGroup[] = await callProcedure('spJBPAssortmentGroup', mappedParams)
    return response.sort((a, b) => a.SortOrder - b.SortOrder)
  } catch (e) {
    return []
  }
}
